import React from 'react'

import moment from 'moment'

import {
    Card,
    Row,
    Col,
    Input,
    Button
} from 'antd'

import './index.css'

class BugComments extends React.Component{

    state = {
        comment: false,
        replyToComment: '',
        replyToIndex: -1,
    }

    render(){

        const { comments } = this.props

        return (
            <Card
                bordered={false}
                title={"Comments"}
            >   
                <div style={{marginBottom: 24}}>
                {comments.length == 0 ?
                "No comments yet"
                :
                comments
                .filter(_comment => _comment.parent == -1)
                .map((_comment,index) => this.renderParentComment(_comment,index))
                }
                </div>

                <div className="reply-to-container">
                    <div>
                        <p className="reply-to-title">Replying To:</p>
                        <p className="reply-to-message">{this.state.replyToComment}</p>
                    </div>
                    <Button type="default" shape="circle" size="small" icon="close" onClick={this.cancelReplyToText} className="reply-to-close"/>
                </div>

                <Input.TextArea
                    value={this.state.comment}
                    style={{marginBottom: 24}}
                    rows={3}
                    onChange={this.handleInputChange}
                />
                <Row type="flex" justify="end">
                    <Button
                        onClick={this.handleSubmitComment}
                    >Comment</Button>
                </Row>

            </Card>
        )
    }

    handleSubmitComment = () => {
        
        const { bugId } = this.props
        const { comment, replyToIndex } = this.state
        this.props.handleSubmitComment({bugId, comment, parent: replyToIndex})
        this.setState({
            comment: false
        })
    }

    handleInputChange = (e) => {
        this.setState({
            comment: e.target.value
        })
    }

    renderParentComment = (_comment, index) => {

        const { comments } = this.props

        return (
            <div key={index}>
            <div className="parent-comment" key={`comment-${_comment._id}`}>
                <div>{_comment.text}</div>
                <div style={{fontSize: 12, display:'flex'}}>
                    <span>
                        {_comment.name} | {moment(_comment.dateCreated).format("MMMM DD, YYYY h:mm A")}
                    </span>
                    <a style={{marginLeft: 'auto'}} onClick={() => this.replyToClicked({_comment, index})}>Reply</a>
                </div>
            </div>
            
            {comments
            .filter(_comment => _comment.parent == index)
            .map(_comment => this.renderChildComment(_comment,index))
            }
            </div>
        )
    }

    renderChildComment = (_comment, index) => {
        return (
            <div className="child-comment" key={`comment-${_comment._id}`}>
                <div>{_comment.text}</div>
                <div style={{fontSize: 12, display:'flex'}}>
                    <span>
                        {_comment.name} | {moment(_comment.dateCreated).format("MMMM DD, YYYY h:mm A")}
                    </span>
                    <a style={{marginLeft: 'auto'}} onClick={() => this.replyToClicked({_comment , index})}>Reply</a>
                </div>
            </div>
        )
    }

    replyToClicked = ({_comment, index}) => {

        this.setState({
            replyToComment: _comment.text,
            replyToIndex: _comment.parent >= 0  ?  _comment.parent : index
        })
    }

    cancelReplyToText = () => {
        this.setState({
            replyToComment: '',
            replyToIndex: -1
        })
    }
}

export default BugComments


// WEBPACK FOOTER //
// ./src/components/bug-report/comments.js